// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import industry from './metaData/industry'
export default {
  state: industry,
  actions
}
